export enum IncentiveCategories {
  BRONZE = 'Bronze',
  PRATA = 'Prata',
  OURO = 'Ouro',
  DIAMANTE = 'Diamante',
  SAME_DAY = 'same_day',
}
